import { Result } from '@/reservation/reservation.model';
import {
	EventsGuides,
	ReservationsCountTransport,
	SlotsCountTransport,
	TourismEvents,
	TransportTermData,
	TransportTermList,
} from '@/bag/bag-transport-term/bag-transport-term.model';
import { DatePipe } from '@angular/common';

type CountTransport =
	| (SlotsCountTransport & { kind: 'slots' })
	| (ReservationsCountTransport & { kind: 'reservations' });

const WEEKDAY = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];

export function getTransportTermColor(status: number): string {
	switch (status) {
		case 100:
			return 'green';
		case 75:
			return 'blue';
		case 50:
			return 'white';
		case 25:
			return 'gray';
		case 0:
			return 'red';
		default:
			return 'white';
	}
}

export class ProcessBagTransportTermData {
	constructor(private readonly datePipe: DatePipe) {}

	afterConvertData(data: Result<TransportTermList>, eventsGuides: EventsGuides[]): TransportTermList[] {
		return data?.results.map((obj) => ({
			...obj,
			departureTime: obj.departureTime ? this.dateFormat(obj.departureTime) : '',
			departureTimeDay: obj.departureTime ? this.getWeekday(obj.departureTime) : '',
			accommodation: {
				...obj.accommodation,
				lowerDay: this.getWeekday(obj.accommodation.lower),
				upperDay: this.getWeekday(obj.accommodation.upper),
			},
			returnTime: obj.returnTime ? this.dateFormat(obj.returnTime) : '',
			returnTimeDay: obj.returnTime ? this.getWeekday(obj.returnTime) : '',
			touristGuides: this.getTouristGuides(obj.termtourismeventSet, eventsGuides),
			highlightLastSeats: obj.highlightLastSeats,
			slots: this.countConfirmSumOfTransport({ ...obj.sumOfTransport.slots, kind: 'slots' }),
			reservations: this.countConfirmSumOfTransport({ ...obj.sumOfTransport.reservations, kind: 'reservations' }),
			color: this.getColor(obj.status),
		}));
	}

	private getColor(status: number): string {
		switch (status) {
			case 100:
				return 'green';
			case 75:
				return 'blue';
			case 50:
				return 'white';
			case 25:
				return 'gray';
			case 0:
				return 'red';
		}
		return 'white';
	}

	private getWeekday(date: string): string {
		const dateObj = new Date(date);
		return WEEKDAY[dateObj.getDay()];
	}

	private countConfirmSumOfTransport(element: CountTransport): CountTransport {
		if (element.kind === 'slots') {
			const { returnSlotsCount, returnSlotsCountOptional, departureSlotsCount, departureSlotsCountOptional } =
				element;
			return {
				...element,
				returnConfirm: returnSlotsCount - returnSlotsCountOptional,
				departureConfirm: departureSlotsCount - departureSlotsCountOptional,
			};
		}

		const {
			returnReservationCount,
			returnReservationCountOptional,
			departureReservationCount,
			departureReservationCountOptional,
		} = element;
		return {
			...element,
			returnConfirm: returnReservationCount - returnReservationCountOptional,
			departureConfirm: departureReservationCount - departureReservationCountOptional,
		};
	}

	private getTouristGuides(tourismEvents: TourismEvents[], eventsGuides: EventsGuides[]): string[] {
		return eventsGuides
			.filter((element) => tourismEvents.find((v) => v.eventId === element.event))
			.map((y) => y.name);
	}

	private dateFormat(date: string): string {
		return this.datePipe.transform(date, 'yyyy-MM-dd');
	}
}
